import React from "react";
import Banner6 from "../partials/Banner/Banner6";
import Section1 from "../includes/CamerasAreNotEffective/Section1";
import { Helmet } from "react-helmet";

const CamerasAreNotEffective = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://brainbox.company/blogs/cameras-does-not-porch-piracy",
    },
    headline: "Why cameras are not effective in stopping porch pirates?",
    image: "https://brainbox.company/images/blogs/blog-8.png",
    author: {
      "@type": "Organization",
      name: "Brain Box",
      url: "https://brainbox.company",
    },
    publisher: {
      "@type": "Organization",
      name: "Brain Box",
      logo: {
        "@type": "ImageObject",
        url: "https://brainbox.company/images/logo-b.png",
      },
    },
    datePublished: "2023-04-04",
    dateModified: "2023-04-05",
  };

  const imgPath = "url(" + devUrl + "images/our-team/ourteam-banner.png)";

  const bgColor = "$blue-color";
  const minHeight = "400px";

  return (
    <>
      <Helmet>
        <title>Why cameras are not effective in stopping porch pirates?</title>
        <meta
          name="description"
          content="Cameras can be a good deterrent for porch pirates but are not effective. Here are a few reasons why cameras are not enough to prevent porch piracy."
        />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
        <link
          rel="canonical"
          href="https://brainbox.company/blogs/cameras-does-not-porch-piracy"
        />
      </Helmet>
      <main>
        <article className="our-team">
          <Banner6
            imgPath={imgPath}
            bgColor={bgColor}
            minHeight={minHeight}
            text1={"Are cameras ineffective in stopping porch pirates?"}
          />
          <div className="bg-design">
            <Section1 url={devUrl} />
          </div>
        </article>
      </main>
    </>
  );
};

export default React.memo(CamerasAreNotEffective);
